<template>
  <div class="dsfa-sc-area-informant">
    <DsfSCPanel
      title="各地区填报数（当日）"
      :iconUrl="iconUrl"
      :more="true"
      @moreClick="moreClick"
    >
      <div class="dsfa-sc-area-informant-table-wrap">
        <table class="dsfa-sc-table">
          <thead class="dsfa-sc-thead">
            <!-- <th class="dsfa-sc-thead-th">序号</th> -->
            <th class="dsfa-sc-thead-th">区域</th>
            <th class="dsfa-sc-thead-th">
              <div class="dsfa-sc-thead-td-data" @click="toggle">
                数量
                <span class="dsfa-sc-table-caret-wrapper">
                  <i class="ort-caret el-icon-caret-top" :class="{active: sortStatus === 1}" @click.stop="sortList(newList,'top')"></i>
                  <i class="sort-caret el-icon-caret-bottom" :class="{active: sortStatus === 2}" @click.stop="sortList(newList,'bottom')"></i>
                </span>
              </div>
            </th>
            <th class="dsfa-sc-thead-th">同比增长</th>
            <th class="dsfa-sc-thead-th">环比增长</th>
          </thead>
          <tbody class="dsfa-sc-tbody">
            <tr class="dsfa-sc-tbody-tr" v-for="(item, index) in newList" :key="index">
              <!-- <td class="dsfa-sc-tbody-td">
                <img :src="item.imgUrl" alt="" />
              </td> -->
              <td class="dsfa-sc-tbody-td">
                {{ item.area }}
              </td>
              <td class="dsfa-sc-tbody-td">
                <div class="dsfa-sc-tbody-td-data">
                  <DsfSCCountTo :num="item.data"></DsfSCCountTo>
                </div>
              </td>
              <td class="dsfa-sc-tbody-td">
                <div class="dsfa-sc-tbody-td-data">
                  <DsfSCCountTo :num="item.up1.data"></DsfSCCountTo>
                  <span class="unit">%</span>
                  <img
                    src="~_statistics-cloud/assets/styles/img/leaderCockpit/icon-down.png"
                    alt=""
                    v-if="item.up1.data < 0"
                  />
                  <img
                    src="~_statistics-cloud/assets/styles/img/leaderCockpit/icon-up.png"
                    alt=""
                    v-if="item.up1.data > 0"
                  />
                </div>
              </td>
              <td class="dsfa-sc-tbody-td">
                <div class="dsfa-sc-tbody-td-data">
                  <DsfSCCountTo :num="item.up2.data"></DsfSCCountTo>
                  <span class="unit">%</span>
                  <img
                    src="~_statistics-cloud/assets/styles/img/leaderCockpit/icon-down.png"
                    alt=""
                    v-if="item.up2.data < 0"
                  />
                  <img
                    src="~_statistics-cloud/assets/styles/img/leaderCockpit/icon-up.png"
                    alt=""
                    v-if="item.up2.data > 0"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </DsfSCPanel>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSCAreaInformant",
  ctrlCaption: "各地区填报数（当日）TOP5",
  mixins: [$mixins.control],
  inject: ["page"],
  data() {
    return {
      iconUrl: require("../../../assets/styles/img/leaderCockpit/icon-gdq.png"),
      dataMap: {},
      // list: [],
      constList: [],
      newList: [],
      isUpSort: true, // 是否为升序
      sortStatus: 0,  // 1 升序  2 降序 0 重置
    };
  },
  watch: {
    "page.acNav": {
      handler(newVal) {
        console.log(this.page.acNav)
        this.newList=this.dataMap[newVal] || []
        this.constList=JSON.parse(JSON.stringify(this.newList));
      },
      deep: true,
      immediate:true
    },
  },
  computed: {
    
  },
  created() {
    this.$http.get("/static/data/dsf.scareainformant.json").then(({ data }) => {
      this.dataMap = data || {};
      this.newList=this.dataMap[this.page.acNav] || []
      this.constList=JSON.parse(JSON.stringify(this.newList));
    });
  },
  methods: {
    // 排序
    sortList(list,sort) {
      console.log('排序')
      list.sort((a, b) => { // 降序
        return Number(a.data) - Number(b.data);
      });
      if (sort==='bottom') {
        list.reverse();
        this.sortStatus = 2;
      }else {
        this.sortStatus = 1; // 升序
      }
    },
    // 切换
    toggle() {
      console.log(this.newList);
      if (this.sortStatus === 0) {
        this.sortList(this.newList,'top')
      } else if (this.sortStatus === 1) {
        this.sortList(this.newList,'bottom')
      } else if (this.sortStatus === 2) {
        this.sortStatus = 0;
        this.newList = JSON.parse(JSON.stringify(this.constList));
      }
    },
    moreClick(args) {
      dsf.layer.openDialog.call(this, {
        title: "各地区填报数（当日）",
        className: "dsfa-sc-area-informant-table-dialog dsfa-sc-dialog",
        content: "DSFSCAreaInformantTable",
      });
    },
  },
});
</script>

<style lang="scss">
@import '_statistics-cloud/assets/styles/pc/areaInformant.scss';
</style>
